<template>
    <lnb class="lnb--all-white">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </lnb>
</template>

<script>
import Lnb from "@/components/publish/styles/headers/lnb.vue";

export default {
    props: {},
    components: {
        Lnb,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss">
// 사용시 주석을 풀어 사용합니다.
.header__bg {
    background-color: rgba(255, 255, 255, 1) !important;
    border: none;
}
.scroll-active {
    .header__bg {
        background-color: rgba(255, 255, 255, 0.8) !important;
    }
}
</style>
<style lang="scss" scoped>
.lnb--all-white ::v-deep {
    line-height: 1.35;
    padding: 32px 0;
    background-color: transparent;
    > li {
        > a {
            font-weight: 400;
            color: var(--v-grey-lighten1);
            padding: 8px;
            &:hover {
                color: var(--v-primary-base);
            }
        }
    }
}
</style>
